import React from 'react';
import {
    SwapHoriz,
    QrCode,
    Link
} from '@mui/icons-material';

const TransactionTabs = ({ activeTab, onTabChange, counts = {} }) => {
    const tabs = [
        {
            id: 'all',
            label: 'Toutes les Transactions',
            icon: SwapHoriz,
            count: counts.all || 0,
            description: 'Vue globale de toutes les transactions'
        },
        {
            id: 'paymentRequests',
            label: 'Demandes de Paiement',
            icon: QrCode,
            count: counts.paymentRequests || 0,
            description: 'Requêtes de paiement en attente'
        },
        {
            id: 'paymentLinks',
            label: 'Liens de Paiement',
            icon: Link,
            count: counts.paymentLinks || 0,
            description: 'Liens de paiement générés'
        }
    ];

    return (
        <div className="bg-white rounded-2xl p-2 border border-gray-200 shadow-sm">
            <div className="flex flex-col lg:flex-row lg:space-x-2">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.id;

                    return (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`flex items-center space-x-3 p-4 rounded-xl transition-all duration-300 text-left flex-1 min-w-0 ${
                                isActive
                                    ? 'bg-gradient-to-r from-amber-50 to-cyan-10 border border-amber-200 shadow-sm'
                                    : 'text-gray-600 hover:bg-gray-50 hover:border hover:border-gray-200'
                            }`}
                        >
                            <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                                isActive
                                    ? 'bg-gradient-to-r from-amber-500 to-amber-500'
                                    : 'bg-gray-100'
                            }`}>
                                <Icon className={`text-lg ${
                                    isActive ? 'text-white' : 'text-gray-500'
                                }`} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center space-x-2">
                                    <h4 className={`font-semibold ${
                                        isActive ? 'text-amber-900' : 'text-gray-900'
                                    }`}>
                                        {tab.label}
                                    </h4>
                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                                        isActive
                                            ? 'bg-amber-500 text-white'
                                            : 'bg-gray-200 text-gray-700'
                                    }`}>
                                        {tab.count}
                                    </span>
                                </div>
                                <p className={`text-sm mt-1 ${
                                    isActive ? 'text-amber-700' : 'text-gray-600'
                                }`}>
                                    {tab.description}
                                </p>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TransactionTabs;